import { alpha, CircularProgress, Paper, Stack, styled } from "@mui/material";
import type { PaperProps } from "@mui/material/Paper";
import type { InternalButtonLinkProps } from "../../components/InternalButtonLink";
import { InternalButtonLink } from "../../components/InternalButtonLink";
import { MuiImage as BaseMuiImage } from "../../components/MuiImage";
import { BodyTextL, BodyTextM, BodyTextS, HeadingM, HeadingS } from "../../components/Typography";

export const Spacer = styled("div")(({ theme }) =>
    theme.unstable_sx({
        mb: 9,
    }),
);

export const Heading = styled(HeadingM)(({ theme }) =>
    theme.unstable_sx({
        m: 5,
    }),
);

export const BodyText = styled(BodyTextL)(({ theme }) =>
    theme.unstable_sx({
        textAlign: "center",
        fontWeight: theme.typography.fontWeightBold,
    }),
);

export const BodyDescription = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        textAlign: "center",
    }),
);

// Invariant Paper props (elevation=0, square false by default) baked into wrapper per guidelines
export const Wrapper = styled((props: PaperProps) => <Paper elevation={0} {...props} />)(({ theme }) =>
    theme.unstable_sx({
        p: 5,
        m: 5,
        boxShadow: (theme) => theme.customShadows.close,
        borderRadius: 1,
        backgroundColor: "white.main",
    }),
);

export const SectionHeading = styled(HeadingS)(({ theme }) =>
    theme.unstable_sx({
        mb: 2,
    }),
);

export const Description = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        mb: 3,
    }),
);

export const OfferSection = styled("div")(({ theme }) =>
    theme.unstable_sx({
        mb: 4,
    }),
);

export const OfferTitle = styled(BodyTextS)(({ theme }) =>
    theme.unstable_sx({
        fontWeight: 600,
        mb: 2,
    }),
);

// Invariant variant/color moved here so usage stays <Styled.ContinueButton onClick=...>
export const ContinueButton = styled((props: InternalButtonLinkProps) => <InternalButtonLink fullWidth {...props} />)(
    ({ theme }) => theme.unstable_sx({}),
);

export const ContinueButtonWrapper = styled("div")(({ theme }) =>
    theme.unstable_sx({
        boxShadow: `0 -4px 8px 0 ${alpha(theme.palette.common.black, 0.1)}`,
        m: 0,
        p: 5,
    }),
);

export const ImageWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        overflow: "hidden",
        p: 5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }),
);

export const MuiImage = styled(BaseMuiImage)(({ theme }) => ({
    height: "auto",
    width: "auto",
}));

export const Progress = styled(CircularProgress)(({ theme }) => ({
    color: theme.palette.common.white,
}));
